import { useParams, Navigate } from "react-router-dom";
import { LEGAL_DOCS } from "../data/legal";
import { Seo } from "../lib/seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";

export const LegalPage = () => {
  const { doc } = useParams();
  const content = LEGAL_DOCS[doc];
  if (!content) return <Navigate to="/404" replace />;

  return (
    <>
      <Seo
        title={content.title}
        description={content.intro.slice(0, 155)}
        path={`/${doc}`}
      />
      <PageHero eyebrow="Legal" title={[content.title + "."]} description={content.intro} />
      <section className="bg-white py-20 sm:py-24">
        <div className="container-x max-w-3xl">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gold-dark">
              {content.updated}
            </p>
            <div className="prose-legal mt-12">
              {content.sections.map((s) => (
                <div key={s.h}>
                  <h2>{s.h}</h2>
                  {s.p?.map((t, i) => (
                    <p key={i}>{t}</p>
                  ))}
                  {s.list && (
                    <ul>
                      {s.list.map((t, i) => (
                        <li key={i}>{t}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default LegalPage;
